module.exports = __webpack_public_path__ + "static/img/1-2.d221be3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/1-2.png
// module id = M5Rt
// module chunks = 0